import Trans from "features/translation/components/Trans";
import PropTypes from 'prop-types';
import { useState } from "react";
import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import useData from "hooks/useData";

const MessageDelete = ({ id, onCompleted }) => {
  const { hideDialog } = useDialog();
  const { deleteData } = useData();
  const [ loading, setLoading ] = useState(false);
  const [ error, setError ] = useState();

  const onExecute = async () => {
    setError();
    setLoading(true);

    const result = await deleteData(`rest/message/${ id }`);
    if (result?.status === 204) {
      if (onCompleted) {
        onCompleted(id);
      }
      hideDialog();
    } else {
      setError(`Het bericht kon niet worden verwijderd (${ result?.status })`);
    }

    setLoading(false);
  };

  return (
    <Dialog title={ 'Bericht verwijderen' }
            loading={ loading }
            errorMessage={ error }>
      <div className={ `dialog__row` }>
        <h3>Weet u zeker dat u dit bericht wilt verwijderen?</h3>
        <div className={"text-small italic"}>
          <Trans text={"Het bericht wordt alleen uit uw eigen berichtenbox verwijderd, in de berichtenbox van uw gesprekspartner blijft het bericht aanwezig."} />
        </div>
      </div>
      <div className="dialog__buttons dialog__buttons">
        <Button onClick={ () => hideDialog() }>Annuleren</Button>
        <Button onClick={ onExecute } variant="secondary">Verwijderen</Button>
      </div>
    </Dialog>
  )
}

MessageDelete.propTypes = {
  id: PropTypes.number.isRequired,
  onCompleted: PropTypes.func
}

export default MessageDelete;
